import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaChevronDown, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/FareFuel_logo.png';

const Header = () => {
   const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
   const [showLangDropdown, setShowLangDropdown] = useState(false);
   const [selectedLang, setSelectedLang] = useState('en');
   const [isLoggedIn, setIsLoggedIn] = useState(false);
   const navigate = useNavigate();
   // const [showRecycleDropdown, setShowRecycleDropdown] = useState(false);

   useEffect(() => {
      const checkSession = () => {
         const token = sessionStorage.getItem('token');
         setIsLoggedIn(!!token);
      };

      checkSession();
      window.addEventListener('storage', checkSession);

      return () => window.removeEventListener('storage', checkSession);
   }, []);

   const changeLanguage = (lang) => {
      const select = document.querySelector('select.goog-te-combo');
      if (select) {
         select.value = lang;
         select.dispatchEvent(new Event('change'));
         setSelectedLang(lang);
         setShowLangDropdown(false);
      }
   };

   const handleLogout = () => {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userEmail');
      sessionStorage.removeItem('userType');
      setIsLoggedIn(false);
      navigate('/');
   };

   return (
      <header className="sticky top-0 z-50 w-full shadow-sm">
         {/* Top Bar (desktop only) */}
         <div className="hidden lg:flex justify-end items-center px-8 py-4 bg-[#9cc026]">
            <div className="flex items-center space-x-6 text-base text-white">
               {/* Desktop Language Switcher */}
               <div className="relative">
                  <button
                     onClick={() => setShowLangDropdown(!showLangDropdown)}
                     className="notranslate flex items-center space-x-1 text-white"
                  >
                     <span className="uppercase">{selectedLang}</span>
                     <FaChevronDown className="text-xs" />
                  </button>
                  {showLangDropdown && (
                     <ul className="absolute right-0 mt-2 bg-white text-gray-700 border rounded shadow z-50">
                        <li>
                           <button onClick={() => changeLanguage('en')} className="notranslate px-4 py-2 hover:bg-gray-100 w-full text-left">English </button>
                        </li>
                        <li>
                           <button onClick={() => changeLanguage('es')} className="notranslate px-4 py-2 hover:bg-gray-100 w-full text-left">Spanish </button>
                        </li>
                     </ul>
                  )}
               </div>
               <div id="google_translate_element" className="hidden"></div>

                {!isLoggedIn ? (
                  <><Link to="/login">Login</Link><Link to="/redemption-login" className="ml-4">Redemption Login</Link></>
               ) : (
                  <button
                     onClick={handleLogout}
                     className="text-red-600 hover:text-red-800"
                  >
                     Logout
                  </button>
                  
               )}

               {/* <Link to="/account">My Account</Link> */}
            </div>
         </div>

         {/* Navigation Bar */}
         <nav className="bg-gray-200 shadow-inner px-6 py-3">
            <div className="flex items-center justify-between">
               {/* Logo */}
               <img className="logo-img w-32 md:w-40" src={logo} alt="logoimg" />

               {/* Language + Hamburger (Mobile & Tablet) */}
               <div className="flex items-center lg:hidden space-x-4">
                  <div className="relative">
                     <button
                        onClick={() => setShowLangDropdown(!showLangDropdown)}
                        className="flex items-center space-x-1 text-gray-800"
                     >
                        <span className="uppercase">{selectedLang}</span>
                        <FaChevronDown className="text-xs" />
                     </button>
                     {showLangDropdown && (
                        <ul className="absolute right-0 mt-2 bg-white text-gray-700 border rounded shadow z-50">
                           <li>
                              <button
                                 onClick={() => changeLanguage('en')}
                                 className="px-4 py-2 hover:bg-gray-100 w-full text-left"
                              >
                                 English
                              </button>
                           </li>
                           <li>
                              <button
                                 onClick={() => changeLanguage('es')}
                                 className="px-4 py-2 hover:bg-gray-100 w-full text-left"
                              >
                                 Spanish
                              </button>
                           </li>
                        </ul>
                     )}
                  </div>
                  <button
                     onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                     className="text-2xl text-gray-800"
                  >
                     {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                  </button>
               </div>

               {/* Desktop Menu (≥1024px) */}
               <ul className="hidden lg:flex items-center space-x-6 xl:space-x-6 text-sm xl:text-base font-medium text-gray-800">
                  <li><Link to="/" className="hover:text-[#9cc026] transition">Home</Link></li>
                  <li><Link to="/recycle-process" className="hover:text-[#9cc026] transition">Recycle Process</Link></li>
                  <li><Link to="/recycle-items" className="hover:text-[#9cc026] transition">Recycle Items</Link></li>
                  <li><Link to="/fuel-gas-stations" className="hover:text-[#9cc026] transition">Fuel Gas Station</Link></li>
                  <li><Link to="/ev-charging-stations" className="hover:text-[#9cc026] transition">EV Charging Station</Link></li>
                  <li><Link to="/rewards_center" className="hover:text-[#9cc026] transition">Rewards Center</Link></li>
                  <li><Link to="/mobile-bill-pay" className="hover:text-[#9cc026] transition">Mobile Bill Pay</Link></li>
                  <li><Link to="/about" className="hover:text-[#9cc026] transition">About Us</Link></li>
                  <li><Link to="/contact" className="hover:text-[#9cc026] transition">Contact Us</Link></li>
                  <li className="relative group">
                     <Link to="/register" className="inline-flex items-center px-5 py-2 bg-green-600 text-white font-semibold rounded-3xl shadow hover:bg-green-700 transition">
                        Get Recycle 
                     </Link>
                     {/* <ul className="absolute right-0 top-full w-56 bg-white shadow-md rounded-lg hidden group-hover:block z-50">
                        <li>
                           <Link to="/register" className="block px-4 py-2 hover:bg-gray-100">
                              Customer / Driver
                           </Link>
                        </li>
                        <li>
                           <Link to="/redemption-center" className="block px-4 py-2 hover:bg-gray-100">
                              Redemption Center
                           </Link>
                        </li>
                     </ul> */}
                  </li>
               </ul>
            </div>

            {/* Mobile & Tablet Slide-in Menu (≤1023px) */}
            <div
               className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 z-40
               ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}
            >
               <div className="p-4 flex justify-between items-center border-b">
                  <h2 className="text-lg font-bold">Menu</h2>
                  <button onClick={() => setMobileMenuOpen(false)} className="text-2xl text-gray-700">
                     <FaTimes />
                  </button>
               </div>
               <ul className="flex flex-col p-4 space-y-3 text-base font-medium text-gray-800">
                  <li><Link to="/" className="hover:text-[#9cc026] transition">Home</Link></li>
                  <li><Link to="/recycle-process" className="hover:text-[#9cc026] transition">Recycle Process</Link></li>
                  <li><Link to="/fuel-gas-stations" className="hover:text-[#9cc026] transition">Fuel Gas Station</Link></li>
                  <li><Link to="/ev-charging-stations" className="hover:text-[#9cc026] transition">EV Charging Station</Link></li>
                  <li><Link to="/rewards_center" className="hover:text-[#9cc026] transition">Rewards Center</Link></li>
                  <li><Link to="/mobile-bill-pay" className="hover:text-[#9cc026] transition">Mobile Bill Pay</Link></li>
                  {/* <li><Link to="/view-portfolio" className="hover:text-[#9cc026] transition">Portfolio</Link></li> */}
                  <li><Link to="/recycle-items" className="hover:text-[#9cc026] transition">Recycle Items</Link></li>
                  <li><Link to="/about" className="hover:text-[#9cc026] transition">About Us</Link></li>
                  <li><Link to="/contact" className="hover:text-[#9cc026] transition">Contact Us</Link></li>
                  {/* <Link to="/account" className="hover:text-[#9cc026] transition">My Account</Link> */}
                  {!isLoggedIn ? (
   <>
      <li><Link to="/login" className="hover:text-[#9cc026] transition">Login</Link></li>
      <li><Link to="/redemption-login" className="hover:text-[#9cc026] transition">Redemption Login</Link></li>
   </>
) : (
   <li><button onClick={handleLogout} className="text-left text-red-600 hover:text-red-800">Logout</button></li>
)}
                  <li className="relative">
                     <Link
                        to="/register"
                        className="w-full text-left px-4 py-2 bg-[#54BE73] text-white font-semibold rounded-3xl shadow hover:bg-green-700 transition flex justify-between items-center"
                     >
                        Get Recycle
                     </Link>
                     {/* {showRecycleDropdown && (
                        <ul className="mt-2 ml-4 space-y-2 text-gray-800">
                           <li>
                              <Link to="/register" className="block px-4 py-2 rounded hover:bg-gray-100">
                                 Customer / Driver
                              </Link>
                           </li>
                           <li>
                              <Link to="/redemption-center" className="block px-4 py-2 rounded hover:bg-gray-100">
                                 Redemption Center
                              </Link>
                           </li>
                        </ul>
                     )} */}
                  </li>
               </ul>
            </div>

            {/* Overlay */}
            {isMobileMenuOpen && (
               <div
                  onClick={() => setMobileMenuOpen(false)}
                  className="fixed inset-0 bg-black/50 z-30"
               ></div>
            )}
         </nav>
      </header>
   );
};

export default Header;
